import { fvDateUtc } from '@fv/dates'

import type { Opportunity } from '@/types/Opportunity'

export const getBidExpiration = (opportunity: Opportunity) => {
  const bidExpDate = opportunity?.bidExpiration?.utc
    ? fvDateUtc(opportunity.bidExpiration.utc)
    : undefined

  if (!bidExpDate) {
    return {
      isExpired: false,
    }
  }

  return {
    bidExpirationDate: bidExpDate.local().format('ddd MMM D / h:mm A'),
    isExpired: fvDateUtc().isAfter(bidExpDate),
  }
}
